import { render } from "./ClaimImage.vue?vue&type=template&id=10e33f69&scoped=true"
import script from "./ClaimImage.vue?vue&type=script&lang=js"
export * from "./ClaimImage.vue?vue&type=script&lang=js"

import "./ClaimImage.vue?vue&type=style&index=0&id=10e33f69&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e33f69"]])

export default __exports__